import { render, staticRenderFns } from "./AddictiveStuffHabits.vue?vue&type=template&id=a7cac38e&"
import script from "./AddictiveStuffHabits.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffHabits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports